module.exports = __webpack_public_path__ + "static/media/logo_pvcombank.41b77951.svg";